import React from 'react'
import '../cssFiles/Title.css'
function Title() {
    return (
        <div className="title">
            <h2>FireGram</h2>
            <h1>Your Picture</h1>
            <p>“A picture held us captive. And we could not get outside it, for it lay in our language and language seemed to repeat it to us inexorably.”</p>
        </div>
    )
}

export default Title
